<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Campagnes
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>
      <v-btn
        color="blue-grey"
        class="ma-2 white--text"
        rounded
        @click="dialogNewcampagne = !dialogNewcampagne"
      >
        <v-icon left dark> mdi-plus-circle-outline </v-icon>
        Nouvelle Campagne
      </v-btn>
      <v-dialog v-model="dialogNewcampagne" persistent max-width="600px">
        <v-card min-height="470">
          <v-card-title>
            <span class="headline">Campagne</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="formCampagne" v-model="valid" lazy-validation>
              <!--     <v-text-field
                v-model="ll_campagne"
                label="Campagne"
                prepend-icon="label"
                :rules="nameRules"
                required
              ></v-text-field> -->

              <template>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="projetsSelected"
                        :items="projets"
                        label="Selectionnez les projets"
                        persistent-hint
                        item-text="ll_programme"
                        return-object
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      Année:
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <Datepicker
                        :value="this.defaultDate"
                        :format="DatePickerFormat"
                        :language="language"
                        minimum-view="year"
                        name="datepicker"
                        id="input-id"
                        input-class="input-class"
                        v-model="yearselected"
                      ></Datepicker>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-form>
          </v-card-text>
          <v-card-text> </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded class="primary" text @click="closeDialog"
              >Annuler</v-btn
            >
            <v-btn rounded class="primary" text @click="updateCreateCampagne"
              >Sauvegarder</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-tabs v-model="tab" align-with-title>
        <v-tab href="#active"> Campagnes actives</v-tab>
        <v-tab href="#incactive">Campagne inactives</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item value="active">
            
      <v-list>
        <v-list-item
          v-for="(item, index) in _.filter(Campagnes, { active: '1' })"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.ll_campagne" class="font-weight-bold"></v-list-item-title>
            <v-list-item-subtitle
              v-html="item.abbr_bailleur"
            ></v-list-item-subtitle>
            <v-list-item-subtitle
              v-html="item.ll_bailleur"
            ></v-list-item-subtitle>
            <v-list-item-subtitle v-html="item.projet"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action
            ><v-btn
              @click="desactiverCampagne(item)"
              x-small
              rounded
              v-if="item.active === '1'"
              color="primary"
              >Désactiver</v-btn
            >
            <v-btn
              @click="activerCampagne(item)"
              rounded
              x-small
              v-else
              color="warning"
              >activer</v-btn
            >
          </v-list-item-action>
        </v-list-item>
      </v-list>
            </v-tab-item>
          <v-tab-item value="incactive"
            >
            
                <v-list>
        <v-list-item
          v-for="(item, index) in _.filter(Campagnes, { active: '0' })"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.ll_campagne" class="font-weight-bold"></v-list-item-title>
             <v-list-item-subtitle
              v-html="item.abbr_bailleur"
            ></v-list-item-subtitle>
            <v-list-item-subtitle
              v-html="item.ll_bailleur"
            ></v-list-item-subtitle>
            <v-list-item-subtitle v-html="item.projet"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action
            ><v-btn
              @click="desactiverCampagne(item)"
              x-small
              rounded
              v-if="item.active === '1'"
              color="primary"
              >Désactiver</v-btn
            >
            <v-btn
              @click="activerCampagne(item)"
              rounded
              x-small
              v-else
              color="warning"
              >activer</v-btn
            >
          </v-list-item-action>
        </v-list-item>
      </v-list>
          </v-tab-item></v-tabs-items
        >
      </v-tabs>

    </v-card-text>
  </v-card>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      tab: "active",
      yearselected: this.$moment().format("YYYY"),
      defaultDate: this.$moment().format("YYYY-MM-DD"),
      DatePickerFormat: "yyyy",
      language: {
        language: "Japanese",
        months: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],
        monthsAbbr: [
          "Jan",
          "Fév",
          "Mar",
          "Avr",
          "Mai",
          "Juin",
          "Juil",
          "Août",
          "Sep",
          "Oct",
          "Nov",
          "Déc",
        ],
        days: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
        rtl: false,
        ymd: false,
        yearSuffix: "",
      },

      idCampagne: null,
      ll_campagne: "",
      dialogNewcampagne: false,
      projetsSelected: "",
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  created() {
    this.GetAllCampagnes();
    this.getProjets();
  },
  methods: {
    closeDialog() {
      this.dialogNewcampagne = false;
      this.idCampagne = null;
      this.$refs.formCampagne.reset();
    },

    updateCreateCampagne() {
      let self = this;
      let uuid = "0000000000000000aaaaa-Campagnes-" + this.$uuid.v4();
      if (this.$refs.formCampagne.validate()) {
        if (!this.idCampagne) {
          console.log("Nouvelle Campagne");
          const newCampagne = {
            ll_campagne:
              this.projetsSelected.ll_programme +
              " " +
              this.$moment(this.yearselected).format("YYYY"),
            ll_bailleur: this.projetsSelected.ll_bailleur,
            abbr_bailleur: this.projetsSelected.abbr_bailleur,
            ll_programme: this.projetsSelected.ll_programme,
            projet: this.projetsSelected.ll_programme,
            bailleurs_id_bailleur: this.projetsSelected.bailleurs_id_bailleur,
            id_bailleur: this.projetsSelected.id_bailleur,
            programme_id_programme: this.projetsSelected.id,
            objectifs: this.projetsSelected.objectifs,
            annee: this.$moment(this.yearselected).format("YYYY"),
            active: "1",
          };
          console.log(newCampagne);
          this.$firebase
            .firestore()
            .collection("campagnes")
            .doc(uuid)
            .set(newCampagne)
            .then(function () {
              console.log("newCampagne successfully written!", newCampagne);
              self.idCampagne = null;
              self.closeDialog();
              self.GetAllCampagnes();
            })
            .catch(function (error) {
              console.error("Error writing newIdEtape: ", error);
            });
        } else {
          console.log("Edition de "), this.idCampagne;

          const updatedCampagne = {
            //
          };

          /*    this.$firebase
            .firestore()
            .collection("campagnes")
            .doc(self.idCampagne);
          DetailEtape.set(updatedCampagne, { merge: true }); */
          //self.GetAllCampagnes(etape.id);
          self.closeDialog(), (self.idCampagne = null);
        }
      }
      this.dialogDetailsEtape = false;
      this.$refs.formCampagne.reset();
    },
    activerCampagne(campagne) {
      let self = this;
      var campagneRef = this.$firebase
        .firestore()
        .collection("campagnes")
        .doc(campagne.id);

      var setWithMerge = campagneRef
        .set(
          {
            active: "1",
          },
          { merge: true }
        )
        .then((docRef) => {
          console.log("Campagne activated with ID: ", campagneRef.id);
          self.GetAllCampagnes();
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
    },
    desactiverCampagne(campagne) {
      let self = this;
      var campagneRef = this.$firebase
        .firestore()
        .collection("campagnes")
        .doc(campagne.id);

      var setWithMerge = campagneRef
        .set(
          {
            active: "0",
          },
          { merge: true }
        )
        .then((docRef) => {
          console.log("Campagne sacrivated with ID: ", campagneRef.id);
          self.GetAllCampagnes();
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
    },

    ...mapActions({
      GetAllCampagnes: "Campagnes/GetAll",
      getProjets: "Projets/getListeProjets",
    }),
  },

  computed: {
    ...mapState({
      Campagnes: (state) => state.Campagnes.Campagnes,
      projets: (state) => state.Projets.projets,
    }),
  },
};
</script>

<style lang="scss" scoped>
.input-class {
  border: 1px grey solid;
  border-radius: 5px;
  padding: 5px;
}
</style>
